// extracted by mini-css-extract-plugin
export default {"fadeIn":"ea5196e859d21e25575a","fadeOut":"ca010a5fde10fc455465"};